module.exports = __webpack_public_path__ + "media/images/img_mansion_selling_graph-db0303066dadd793342b080d5d0b3d38.png";